import React from 'react';
import { Footer, Header } from '@vedmarket/ui-kit';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Menu from '../menu';
import RightPanel from '../right-panel';
import { ROUTES } from '../../config/constants';

import './page-layout.scss';

type PageLayoutProps = {
    children: React.ReactNode;
    hasTitle?: boolean;
    hasRightPanel?: boolean;
    rightPanelTitle?: React.ReactNode;
    rightPanelItems?: React.ReactNode[];
    onRightPanelItemClick?: (index: number) => void;
    rightPanelActiveItemIndex?: number;
};


const KnowledgeBaseHeader = Header as React.ComponentType<React.ComponentProps<typeof Header> & {
    knowledgeBaseSearchValue?: string;
    onKnowledgeBaseSearch?: (query: string) => void;
    onKnowledgeBaseSearchClear?: () => void;
}>;

const PageLayout = ({
    children,
    hasTitle,
    hasRightPanel = true,
    rightPanelTitle,
    rightPanelItems,
    onRightPanelItemClick,
    rightPanelActiveItemIndex,
}: PageLayoutProps) => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const panelTitle = rightPanelTitle || t('common__text__new')
    const panelItems = rightPanelItems || []
    const headerSearch = searchParams.get('q') || ''

    const handleKnowledgeBaseSearch = (query: string) => {
        navigate(`${ROUTES.SEARCH}?q=${encodeURIComponent(query)}`)
    }

    const handleKnowledgeBaseSearchClear = () => {
        navigate(ROUTES.SEARCH)
    }

    return (
        <>
            <KnowledgeBaseHeader
                isKnowledgeBase
                knowledgeBaseSearchValue={headerSearch}
                onKnowledgeBaseSearch={handleKnowledgeBaseSearch}
                onKnowledgeBaseSearchClear={handleKnowledgeBaseSearchClear}
            />
            <div className='layout'>
                <Menu/>
                <div className='content'>
                    <div className={cx('content__left', {
                        'content__left_full': !hasRightPanel,
                    })}>
                        {children}
                    </div>
                    {hasRightPanel && (
                        <div className='content__right'>
                            <div className={cx('content__right-sticky', {
                                'content__right-sticky_hasTitle': hasTitle,
                            })}>
                                <RightPanel
                                    title={panelTitle}
                                    items={panelItems}
                                    onItemClick={onRightPanelItemClick}
                                    activeItemIndex={rightPanelActiveItemIndex}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer isKnowledgeBase/>
        </>
    )
};

export default PageLayout;
